import React, { Component } from 'react'
import PropTypes from 'prop-types'
import formatter from '../../util/formatter'

import './styles.css'

export default class SectionTitle extends Component {
  render () {
    const { className, color, subtitle, title, children } = this.props

    return (
      <div className={formatter.toClassName(['wd-section-title', className])}>
        <div className='wd-title' style={{ display: title ? '' : 'none' }}>
          { title }

          <div>{children}</div>
        </div>
      </div>
    )
  }
}

SectionTitle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  subtitle: PropTypes.node,
  title: PropTypes.node
}
